export default __webpack_public_path__ + "static/media/Group 3200@2x.43007c23.png";